module.exports = __webpack_public_path__ + "media/images/bnr-summer-sale-lg-e8460226ca30dd9d9f6a4845a40ce5a6.png";